import React from "react";
import { FilterSection } from "@/components/ui";

export const MaterialExpensesControlPanel = ({
  search, setSearch,
  filters, setFilters,
  sortBy, setSortBy,
  view, setView,
  onAddClick,
  categories,
  showStats,
  setShowStats,
  addLabel,
  onExport,
  isExporting
}) => {
  return (
    <FilterSection
      search={search}
      setSearch={setSearch}
      filters={filters}
      setFilters={(key, value) => setFilters(prev => ({ ...prev, [key]: value }))}
      // viewStyle={view}
      // setViewStyle={setView}
      onAddClick={onAddClick}
      addLabel={addLabel || "Material Expenses"}
      onExport={onExport}
      isExporting={isExporting}
      // showDetails={showStats}
      // setShowDetails={setShowStats}
      statusOptions={[
        { value: "pending", label: "Pending" },
        { value: "approved", label: "Approved" },
        { value: "partially_approved", label: "Partially Approved" },
        { value: "paid", label: "Paid" },
        { value: "rejected", label: "Rejected" },
        { value: "cancelled", label: "Cancelled" }
      ]}
      statusPlaceholder="All Statuses"
    />
  );
};




